module.exports = __webpack_public_path__ + "static/media/schema_f602.json"